export const ExperimentsRoute = {
  Experiments: 'experiments'
} as const;

export type ExperimentsRoute =
  (typeof ExperimentsRoute)[keyof typeof ExperimentsRoute];

export type ExperimentsParam = {
  [ExperimentsRoute.Experiments]: undefined;
};
